<template>
  <div>
    <el-form ref="formData" :rules="rules" :model="formData" :disabled="readonly" label-position="left"
      label-width="80px" size="small">
      <el-row :gutter="24">
        <el-col :span="24">
          <el-form-item label="事由" prop="reason">
            <el-input v-model.trim="formData.reason" size="small" maxlength="30" show-word-limit
              :disabled="readonlyMode">
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="24">
        <el-col :span="12">
          <el-form-item label="开始时间" prop="startDate">
            <el-date-picker v-model="formData.startDate" type="date" placeholder="选择日期" :disabled="readonlyMode"
              value-format="yyyy-MM-dd HH:mm:ss" style="width:100%" :picker-options="pickerOptionsStart">
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="结束时间" prop="endDate">
            <el-date-picker v-model="formData.endDate" type="date" placeholder="选择日期" :disabled="readonlyMode"
              value-format="yyyy-MM-dd HH:mm:ss" style="width:100%" :picker-options="pickerOptionsEnd">
            </el-date-picker>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-form-item label="扣减调休">{{ formData.deductDays || "-" }}天</el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>

<script>
import { mapState } from "vuex";
const FORMDATA = () => ({
  reason: "",
  startDate: "",
  endDate: ""
});
export default {
  components: {},
  props: {
    list: {
      type: Array,
      required: false,
      default: () => []
    },
    readonly: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      icon: require("@/CommonDP/assets/doc/folder_icon.png"),
      rules: {
        reason: [{ required: true, message: "请填写", trigger: "blur" }],
        startDate: [{ required: true, message: "请选择", trigger: "blur" }],
        endDate: [{ required: true, message: "请选择", trigger: "blur" }]
      },
      // 开始结束日期限制
      pickerOptionsStart: {
        disabledDate: time => {
          if (this.formData.endDate) {
            return time.getTime() >= new Date(this.formData.endDate).getTime();
          }
        }
      },
      // 结束日期限制
      pickerOptionsEnd: {
        disabledDate: time => {
          if (this.formData.startDate) {
            return time.getTime() <= new Date(this.formData.startDate).getTime();
          }
        }
      },
      fileDialog: false,
      defaultFileProps: {
        children: "childList",
        label: "folderName",
        isLeaf: "leaf"
      },
      loading: false,
      node_had: {},
      localTree: [],
      resolve_had: {},
      messageObj: {},
      readonlyMode: this.readonly,
      formData: FORMDATA()
    };
  },
  computed: {
    ...mapState({
      prjInfo: state => state.projectMg.prjObj,
      routerParams: state => state.projectMg.routerParams,
      userInfo: state => state.user.userInfo
    }),
    showBar() {
      return this.$store.state.app.showBar;
    },
    tableData() {
      return this.list || [];
    }
  },
  watch: {
    readonly(newVal) {
      this.readonlyMode = !!newVal;
    }
  },
  async mounted() {
    this.formData.approveUserName = this.userInfo.name;
    this.readonlyMode = this.routerParams.readonly || this.routerParams.flowStatus;
  },
  methods: {
    // 接口：用于获取表单数据
    getFormData() {
      return this.formData;
    },

    // 接口：设置表单数据
    setFormData(formData) {
      this.formData = formData;
    },

    // 接口：校验表单数据
    async validateFormData() {
      return await this.validate();
    },

    // 接口：校验表单数据
    async validate() {
      try {
        return await this.$refs.formData.validate();
      } catch (e) {
        // 校验失败
        return false;
      }
    },
    cancel() {
      this.localTree = [];
    }
  }
};
</script>

<style lang="scss" scoped>
.tree {
  overflow: auto;
  height: 500px;
  max-height: 500px;
  width: 100%;
}
.treeitem {
  display: flex;
  align-items: center;
  user-select: none;
}
.activeShowBar {
  max-height: 300px;
  overflow-y: auto;
}
.img {
  margin-right: 6px;
  height: 16px;
  width: 18px;
  user-select: none;
}
.midd-content {
  line-height: 40px;
}
</style>
